import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderRadius, borderWidth } from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";

/** Figma "Follow up prompt" instance chip — Caption 3 on #F0F6FF. */
export const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: ${spacing[1]} ${spacing[3]};
  background-color: ${rawColors.structural[100]};
  border: ${borderWidth[1]} solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.md};
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
`;
